export const PLAYER_PAGE_ERROR = "PLAYER_PAGE_ERROR";
export const PLAYER_PAGE_ERRORS = {
    PLAYER_PAGE_ERROR: "PLAYER_PAGE_ERROR",
    PLAYER_NOT_FOUND: "DGT404",
};
export const PLAYER_PAGE = "PLAYER_PAGE";
export const PLAYER_PAGE_WIDGET = "PLAYER_PAGE_WIDGET";
export const TRACKED_UPDATE_ENTITIES = {
    ADD: "ADD_PLAYER_DATA",
    CHANGE: "CHANGE_PLAYER_DATA",
    REMOVE: "REMOVE_PLAYER_DATA",
};
//# sourceMappingURL=index.js.map